const links =  [
  {
    name: 'Dashboard',
    icon: 'nc-icon nc-globe',
    path: '/admin/overview',
    visible: ['agent', 'commercial']
  },
  {
    name: 'Terminals',
    icon: 'nc-icon nc-paper',
    path: '/search/terminals',
    visible: ['agent']
  },
  {
    name: 'Users',
    icon: 'nc-icon nc-circle-10',
    path: '/search/users',
    visible: ['agent']
  },{
    name: 'Contracts',
    icon: 'nc-icon nc-box',
    path: '/search/contracts',
    visible: ['agent', 'commercial', 'supplier']
  },
  {
    name: 'New contract',
    icon: 'nc-icon nc-ruler-pencil',
    path: '/forms/wizard',
    visible: ['agent', 'commercial']
  },
    /*
  {
    name: 'New EMS contract',
    icon: 'nc-icon nc-ruler-pencil',
    path: '/pages/ems',
    visible: ['agent', 'commercial']
  }
  
     */
]


export default links
